import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';
import { startWith } from 'rxjs/internal/operators/startWith';

@Component({
  selector: 'app-graph-search',
  templateUrl: './graph-search.component.html',
  styleUrls: ['./graph-search.component.scss'],
})
export class GraphSearchComponent implements OnInit {
  searchSelected: any = null
  element: any = null
  theme: string = 'light';
  colors: any = {
    light: {
      background_image: 'url(assets/images/immersion_assets/background-white.png)'
    }
  }

  constructor(public fb: FormBuilder) {
  }

  ngOnInit() { }

  search() { }

  transformToGraphData(data: any) { }

  onSearch(object: any) {
    this.element = object
    this.searchSelected = true
  }

  goBack(event) {
    this.searchSelected = null
  }
}
